/* BLC v7 - personalizer form behaviour.
   Filename display, 20 MB guard, bulk-threshold messaging, variant
   switching and required-artwork validation.

   Bulk messaging here is DISPLAY ONLY. The actual discount is a
   Shopify automatic product discount with a minimum quantity of 12.

   Strings come from data-* attributes on the root so this file can
   stay a plain cached asset instead of Liquid. */
(function () {
  var MAX_BYTES = 20 * 1024 * 1024;

  function initOne(root) {
    if (root.getAttribute('data-blc7-ready') === 'true') return;
    root.setAttribute('data-blc7-ready', 'true');

    var copy = {
      none:   root.getAttribute('data-copy-none')   || '',
      errReq: root.getAttribute('data-copy-errreq') || '',
      errBig: root.getAttribute('data-copy-errbig') || '',
      adding: root.getAttribute('data-copy-adding') || '',
      each:   root.getAttribute('data-copy-each')   || '',
      money:  root.getAttribute('data-money')       || '${{amount}}'
    };

    var form   = root.querySelector('form');
    var file   = root.querySelector('[data-blc7-file]');
    var fileUi = root.querySelector('[data-blc7-file-ui]');
    var fileNm = root.querySelector('[data-blc7-file-name]');
    var err    = root.querySelector('[data-blc7-err]');
    var qty    = root.querySelector('[data-blc7-qty]');
    var bulk   = root.querySelector('[data-blc7-bulk]');
    var addBtn = root.querySelector('[data-blc7-add]');

    function showError(msg) {
      if (!err) return;
      err.textContent = msg || '';
      err.setAttribute('data-show', msg ? 'true' : 'false');
    }

    /* ---- filename + size guard ---- */
    if (file) {
      file.addEventListener('change', function () {
        var f = file.files && file.files[0];
        showError('');

        if (!f) {
          fileNm.textContent = copy.none;
          fileUi.setAttribute('data-filled', 'false');
          return;
        }
        if (f.size > MAX_BYTES) {
          file.value = '';
          fileNm.textContent = copy.none;
          fileUi.setAttribute('data-filled', 'false');
          showError(copy.errBig);
          /* let the preview module clear itself too */
          file.dispatchEvent(new Event('blc7:cleared'));
          return;
        }
        fileNm.textContent = f.name;
        fileUi.setAttribute('data-filled', 'true');
      });
    }

    /* ---- bulk threshold messaging ---- */
    function syncBulk() {
      if (!bulk || !qty) return;
      var min = parseInt(bulk.getAttribute('data-min'), 10);
      var n = parseInt(qty.value, 10) || 0;
      var on = n >= min;
      bulk.setAttribute('data-active', on ? 'true' : 'false');
      var idle = bulk.querySelector('[data-blc7-bulk-idle]');
      var live = bulk.querySelector('[data-blc7-bulk-on]');
      if (idle) idle.hidden = on;
      if (live) live.hidden = !on;
    }
    if (qty) {
      qty.addEventListener('input', syncBulk);
      qty.addEventListener('change', syncBulk);
    }
    syncBulk();

    /* ---- variant switching ---- */
    var variants = [];
    var vjson = root.querySelector('[data-blc7-variants]');
    if (vjson) { try { variants = JSON.parse(vjson.textContent); } catch (e) { variants = []; } }

    var groups  = [].slice.call(root.querySelectorAll('[data-blc7-opt]'));
    var vid     = root.querySelector('[data-blc7-vid]');
    var priceEl = root.querySelector('[data-blc7-price]');

    function money(c) {
      var n = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return copy.money.replace(/\{\{\s*\w+\s*\}\}/, n);
    }

    if (groups.length && vid) {
      groups.forEach(function (g) {
        g.addEventListener('change', function () {
          var opts = groups.map(function (gr) {
            var c = gr.querySelector('input:checked');
            return c ? c.value : null;
          });
          var found = null;
          for (var i = 0; i < variants.length; i++) {
            var ok = true;
            for (var j = 0; j < opts.length; j++) {
              if (opts[j] !== null && variants[i].options[j] !== opts[j]) { ok = false; break; }
            }
            if (ok) { found = variants[i]; break; }
          }
          if (!found) return;
          vid.value = found.id;
          if (priceEl) priceEl.textContent = money(found.price) + ' ' + copy.each;
        });
      });
    }

    /* ---- submit: plain POST, block only on missing required artwork ---- */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (file && file.getAttribute('data-required') === 'true') {
          if (!file.files || !file.files.length) {
            e.preventDefault();
            showError(copy.errReq);
            file.focus();
            return;
          }
        }
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = copy.adding;
        }
      });
    }
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-blc7-root]')).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
